<template>
<div class="content-main">
    <div class="left-main">
        <div class="left-main-content">
            <div class="title"><span class="colorFB092B">综合</span><span>服务</span></div>
            <div class="sec-title">全球线上外贸综合服务系统为出口工厂提供通关、结汇、退税、物流和金融等全程流程、一站式的线上外综综合服务。<br>
                通过规模效应、缩减换件、减少操作，全面降低工厂出口交易成本，提升用户体验，让工厂专心接单生产，助力川货出川。 </div>
            <div class="text-video-box">
                <div class="left-nav-box">
                    <div :class="{'nav-child':true,'active-nav':item.isClick}" v-for="(item,index) in navList" :key="index" @mouseover="changeNav(item)">
                        <div class="child-left">
                            <div class="line" v-if="item.isClick==true"></div>
                            <div class="triangle" v-else></div>
                            <div class="child-text">{{item.text}}</div>
                        </div>
                        <div class="imgs">
                            <img :src="item.icon" alt="" width="100%" height="100%" v-if="item.isClick">
                        </div>
                    </div>
                </div>
                <div class="right-child-box" v-for="(item,index) in navList" :key="index" v-if="item.id==0&&item.isClick">
                    <div class="childList showBox" index="1" style="display: block;">
                        <div class="child-title">服务内容</div>
                        <ul class="serverList_1">
                            <li>√ 海关关企合作伙伴，享受绿色报关通道。</li>
                            <li>√ 专业通关服务团队，为客户解决通关难题。</li>
                            <li>√ 接入四川单一窗口在线系统，实现一站式线上报关服务。</li>
                        </ul>
                        <div class="child-title">服务流程</div>
                        <div class="server-img-box"> <img id="" src="../assets/images/com1_1.jpg" alt="" class="server-img" width="50%"></div>
                        <div class="child-title">准入条件</div>
                        <div>
                            <ul class="serverList_2">
                                <li>◆ 委托出口的产品需要在外综服可以出口的范围内。（请具体咨询客服人员）</li>
                                <li>◆ 与外综服签约的客户类型：贸易商、生产厂商、个人、国外采购办事处等。</li>
                                <li>◆ 开票人资质必须符合外综服的要求。（请具体咨询客服人员）</li>
                                <li>◆ 出口货物的外汇必须汇入外综服的指定收汇账号。</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="right-child-box" v-for="(item,index) in navList" :key="index" v-if="item.id==1&&item.isClick">
                    <div class="childList" index="3" style="display: block;">
                        <div class="child-title">服务内容</div>
                        <ul class="serverList_1">
                            <li>√ 货物存储、B2C小包发货、B2B批量发货。</li>
                            <li>√ 多仓数据实时采集。</li>
                            <li>√ 补货到FBA/第三方海外仓。</li>
                        </ul>
                        <div class="child-title">服务流程</div>
                        <div class="server-img-box"> <img id="" src="../assets/images/com1_2.jpg" alt="" class="server-img" width="50%"></div>
                        <div class="child-title">服务优势</div>
                        <div>
                            <ul class="serverList_2">
                                <li>◆ 发货快海外仓分布广多国实现本地配送</li>
                                <li>◆ 成本低集体货运，费用均摊，物流成本低</li>
                                <li>◆ 多种交易模式可同时支持零售、批发、及大宗交易的仓储需求</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="right-child-box" v-for="(item,index) in navList" :key="index" v-if="item.id==2&&item.isClick">
                    <div class="childList" index="4" style="display: block;">
                        <div class="child-title">服务内容</div>
                        <ul class="serverList_1">
                            <li>√ 安全高效，结算快、成本低。</li>
                            <li>√ 结汇流程透明，登录我平台“财务中心”，随时可查询结汇明细。</li>
                            <li>√ 与各大银行实现系统直连，线上申请，实时到账，保障资金安全。</li>
                            <li>√ 根据客户需求，提供远期锁汇服务，规避汇率风险，提前锁定利润。</li>
                        </ul>
                        <div class="child-title">服务流程</div>
                        <div class="server-img-box">
                            <img id="" src="../assets/images/com1_3.jpg" alt="" class="server-img" width="50%"></div>
                    </div>
                </div>
                <div class="right-child-box" v-for="(item,index) in navList" :key="index" v-if="item.id==3&&item.isClick">
                    <div class="childList" index="5" style="display: block;">
                        <div class="child-title">服务内容</div>
                        <ul class="serverList_1">
                            <li>√ 享受快速退税绿色通道。</li>
                            <li>√ 正规出口退税，简化退税环节，盘活资金。</li>
                            <li>√ 单证齐全最快3个工作日垫付退税款。</li>
                        </ul>
                        <div class="child-title">服务流程</div>
                        <div class="server-img-box"> <img id="" src="../assets/images/com1_4.jpg" alt="" class="server-img" width="50%"></div>
                        <div class="child-title">退税条件</div>
                        <div class="server-img-box">
                            <ul class="serverList_1">
                                <li>◆ 客户需要具备以下条件方可申报退税：</li>
                            </ul>
                            <div class="server-img-box"> <img id="" src="../assets/images/com1_5.jpg" alt="" class="server-img" width="50%"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <div class="right-main">
        <div class="tagLabel-box">
            <div class="label-top">
                <div :class="{'icon-item':true,'active-icon':item.hasClass}" v-for="(item,index) in list" :key="index" :style="{backgroundImage: `url(${item.hasClass?active_icon:default_icon})`}" @click="changeTag(item)"></div>
            </div>
            <div class="label-bottom">
                <div class="label-bottom-top">
                    <div :class="{'active-child':item.hasClass,'default-child':true}" v-for="(item,index) in list" :key="index" @click="changeTag(item)"></div>
                </div>
                <div class="label-bottom-bottom">
                    <img src="../assets/images/icon_1.png" alt="" width="27px" height="37px">
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import top_active from "../assets/images/top_active.png"
import top_default from "../assets/images/top_default.png"
import com_1 from '@/assets/images/com_1.png'
import com_2 from '@/assets/images/com_2.png'
import com_3 from '@/assets/images/com_3.png'
import com_4 from '@/assets/images/com_4.png'
export default {
    name: "tagFin",
    props: {
        "vdata": {
            type: Array,
            default: [],
        }

    },
    data() {
        return {
            list: [],
            childnavList: [{
                    id: 0,
                    text: "智能通关",
                    isClick: true,
                    icon: com_1
                },
                {
                    id: 1,
                    text: "海外仓储",
                    isClick: false,
                    icon: com_2,
                }, {
                    id: 2,
                    text: "结汇",
                    isClick: false,
                    icon: com_3
                }, {
                    id: 3,
                    text: "退税",
                    isClick: false,
                    icon: com_4
                }
            ],
            default_icon: top_default,
            active_icon: top_active
        }
    },
    created() {
        let curr = this.vdata;
        let result = [];
        //console.log(curr,"curr")
        curr.forEach((item, index) => {
            if (index % 2 == 0) {
                result.push(item);
            }
        })
        this.list = result;
        console.log(this.list, "vdata")
    },
    methods: {
        changeNav(temp) {
            this.navList.forEach((item, index) => {
                if (item.id == temp.id) {
                    this.$set(this.navList, index, {
                        id: item.id,
                        text: item.text,
                        isClick: true,
                        icon: item.icon
                    })
                } else {
                    this.$set(this.navList, index, {
                        id: item.id,
                        text: item.text,
                        isClick: false,
                        icon: item.icon
                    })
                }
            })
        },
        changeTag(item) {
            let curr = this.vdata;
            curr.forEach((tem, index) => {
                console.log(tem.id, item.id)
                if (tem.id == item.id) {
                    console.log(11111)
                    curr[index] = {
                        id: tem.id,
                        text: tem.text,
                        isText: tem.isText,
                        isShow: tem.isShow,
                        hasClass: true,
                    }
                } else {
                    curr[index] = {
                        id: tem.id,
                        text: tem.text,
                        isText: tem.isText,
                        isShow: tem.isShow,
                        hasClass: false,
                    }
                }
            })
            let result = [];
            curr.forEach((item, index) => {
                if (index % 2 == 0) {
                    result.push(item);
                }
            })
            this.list = result;
            this.$emit('godata', {
                item,
                index: item.id
            })
            console.log(curr, "curr")
        }
    }

}
</script>

<style lang="less" scoped>
.active-icon {
    width: 22px !important;
    height: 22px !important;
}

.content-main {
    //background-color: yellowgreen;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    .left-main {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;

        .left-main-content {
            width: 1440px;
            height: 100%;
            display: flex;
            flex-direction: column;
        }
    }

    .right-main {
        position: absolute;
        top: 0;
        right: 0;
        width: 30px;
        height: 100%;
        padding-right: 60px;

        //background-color: rgb(167, 164, 164);
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .tagLabel-box {
            width: 40px;
            height: 100%;
            // margin-top: 160px;
            //border: 1px red solid;
            display: flex;
            justify-content: space-around;
            align-items: center;
            flex-direction: column;

            .label-top {
                width: 100%;
                height: 30%;
                display: flex;
                justify-content: space-around;
                align-items: center;
                flex-direction: column;

                //border: 1px green solid;

                .icon-item {
                    width: 8px;
                    height: 8px;
                    background-size: cover;
                    background-position: center center;
                }
            }

            .label-bottom {
                width: 100%;
                height: 30%;
                //border: 1px green solid;

                .label-bottom-top {
                    width: 100%;
                    height: 80%;
                    //border: 1px red solid;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;
                }

                .label-bottom-bottom {
                    width: 100%;
                    height: 20%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    //border:1px red solid;
                }
            }
        }
    }
}

.colorFB092B {
    color: #FB092B;
}

.title {
    margin-top: 50px;
    color: #fff;
    font-size: 60px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    line-height: 84px;
}

.sec-title {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.75);
    line-height: 26px;
}

.text-video-box {
    margin-top: 50px;
    display: flex;
    flex: 1;
    //border: 1px red solid;
    //min-height: 360px;
    justify-content: space-between;
    align-items: flex-start;

    .left-nav-box {
        width: 30%;
        //height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;

        //border: 1px red solid;
        .nav-child {
            width: 80%;
            height: 100px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            //border: 1px red solid;
            padding-right: 30px;

            .child-left {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                height: 100%;

                .line {
                    width: 4px;
                    height: 40px;
                    background: #FFFFFF;
                    margin-right: 36px;
                }

                .triangle {
                    width: 0;
                    height: 0;
                    border-top: 6px solid transparent;
                    border-left: 12px solid rgba(255, 255, 255, 0.5);
                    border-bottom: 12px solid transparent;
                    margin-right: 36px;
                }

                .child-text {
                    font-size: 24px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 33px;
                }
            }

            .imgs {
                width: 46px;
                height: 46px;
            }
        }
    }

    .right-child-box {
        width: 70%;
        //height: 100%;
        background: #FFFFFF;
        margin-right: 50px;

        border-radius: 0px 16px 0px 16px;

        .childList {
            width: 90%;
            //padding: 50px;
            padding-top: 20px;
            padding-left: 50px;
            //padding: 20px;
            padding-bottom: 20px;
            padding-right: 50px;
            //border:1px red solid;

            .child-title {
                width: 100%;
                font-size: 20px;
                padding-left: 15px;
                line-height: 30px;
                /* background-color: #333; */
                border-left: 5px #b62020 solid;
                /* margin-left: 20px; */
                color: #333;
                margin-bottom: 15px;
                font-weight: bold;
                 margin-top: 30px;
            }

            .server-img-box {
                width: 100%;
                margin-bottom: 10px;
            }

            .serverList_1 {
                list-style-type: none;
                margin-bottom: 10px;
                color: #333;
                font-size: 16px;
                line-height: 2;
            }

            .serverList_2 {
                list-style-type: none;
                color: #333;
                font-size: 16px;
                line-height: 2;
            }
        }
    }
}

.video-box {
    width: 45%;
    min-width: 640px;
    height: 70%;
    border: 1px red solid;
    display: flex;
    min-height: 360px;
    justify-content: center;
    align-items: center;
}

.active-nav {
    background: linear-gradient(135deg, rgba(182, 32, 32, 0.8) 0%, rgba(255, 255, 255, 0.1) 100%);
    border-radius: 0px 16px 0px 16px;
    width: 100%;
}

.text-box {
    width: 45%;
    min-width: 640px;
    height: 70%;
    min-height: 360px;
    //border: 1px red solid;
    padding: 0 20px;

}

.text-title {
    font-size: 30px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FB092B;
    line-height: 42px;
    margin-bottom: 40px;
}

.text {
    width: 640px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.85);
    text-align: justify;
    line-height: 32px;
}

.mgb40 {
    margin-bottom: 40px;
}

.btn-go {
    width: 32px;
    height: 32px;
    background-color: #CC1F37;
    margin-top: 40px;
}

.default-child {
    width: 2px;
    height: 16%;
    background: rgba(255, 255, 255, 0.1);
}

.active-child {
    background: rgba(54, 169, 255, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/tagCom.vue